"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOCK_FILE_TYPE = exports.PORT = exports.PANEL_ID = exports.PARAM_KEY = exports.ADDON_ID = void 0;
var ADDON_ID = 'mockPanel';
exports.ADDON_ID = ADDON_ID;
var PARAM_KEY = 'mockPanel';
exports.PARAM_KEY = PARAM_KEY;
var PANEL_ID = "".concat(ADDON_ID, "/panel");
exports.PANEL_ID = PANEL_ID;
var PORT = 6161;
exports.PORT = PORT;
var MOCK_FILE_TYPE = 'json';
exports.MOCK_FILE_TYPE = MOCK_FILE_TYPE;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jb25zdGFudHMudHMiXSwibmFtZXMiOlsiQURET05fSUQiLCJQQVJBTV9LRVkiLCJQQU5FTF9JRCIsIlBPUlQiLCJNT0NLX0ZJTEVfVFlQRSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQU8sSUFBTUEsUUFBUSxHQUFHLFdBQWpCOztBQUNBLElBQU1DLFNBQVMsR0FBRyxXQUFsQjs7QUFDQSxJQUFNQyxRQUFRLGFBQU1GLFFBQU4sV0FBZDs7QUFDQSxJQUFNRyxJQUFJLEdBQUcsSUFBYjs7QUFDQSxJQUFNQyxjQUFjLEdBQUcsTUFBdkIiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgQURET05fSUQgPSAnbW9ja1BhbmVsJztcbmV4cG9ydCBjb25zdCBQQVJBTV9LRVkgPSAnbW9ja1BhbmVsJztcbmV4cG9ydCBjb25zdCBQQU5FTF9JRCA9IGAke0FERE9OX0lEfS9wYW5lbGA7XG5leHBvcnQgY29uc3QgUE9SVCA9IDYxNjE7XG5leHBvcnQgY29uc3QgTU9DS19GSUxFX1RZUEUgPSAnanNvbic7Il19